import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { TaraFloatingActionButton } from '../components/features/Tara';
import { actions } from '../actions/tara';
import { getHasAnsweredSurvey } from '../reducers/tara/hasAnsweredSurvey';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';
import { getIsFetching } from '../reducers/tara/isFetching';
import { getStatus } from '../reducers/tara/status';
import { getTaraSurvey } from '../reducers/tara/survey';

class TaraFloatingActionButtonContainer extends React.PureComponent {
  componentDidMount() {
    if (!this.props.survey) {
      this.props.taraGetSurveyRequest();
    }
  }

  handleClick = (e) => {
    this.props.taraSetSurveyCompleted(false);
  };

  render() {
    return (
      <TaraFloatingActionButton
        {...this.props}
        onClick={this.handleClick}
      />
    );
  }
}

const getState = (state, ownProps) => ({
  hasAnsweredSurvey: getHasAnsweredSurvey(state),
  survey: getTaraSurvey(state),
  ...ownProps,
});

const getActions = dispatch => bindActionCreators({
  taraSetSurveyCompleted: actions.taraSetSurveyCompleted,
  taraGetSurveyRequest: actions.taraGetSurveyRequest,
  taraPostSurveyRequest: actions.taraPostSurveyRequest,
}, dispatch);

export default connect(getState, getActions)(TaraFloatingActionButtonContainer);



// WEBPACK FOOTER //
// ./src/containers/TaraFloatingActionButtonContainer.js